<template>
    <el-select :disabled="disabled" v-if="parent" v-model="val" @change="handleChange" placeholder="请选择分类">
        <el-option v-for="item in options" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
    </el-select>
    <el-cascader
        :disabled="disabled"
        v-else
        v-model="val"
        :options="options"
        @change="handleChange"
        :props="{ value: 'uuid', label: 'name', emitPath: false }"
        placeholder="请选择分类"
    ></el-cascader>
</template>

<script>
import { list } from "@/api/video/category";
export default {
    props: {
        value: {
            type: String | Array,
            default: "",
        },
        parent: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            list({
                page_index: 1,
                page_size: 9999,
            }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.options = result.data || [];
                    this.formatOptions();
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        formatOptions() {
            const deep = (options) => {
                options.forEach((option) => {
                    if (option.children.length == 0) {
                        option.children = null;
                        return;
                    } else {
                        deep(option.children);
                    }
                });
            };
            deep(this.options);
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
